var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Type = require("./Type.js");

module.exports = /*#__PURE__*/function () {
  "use strict";

  function RangeContainer() {
    var ranges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, RangeContainer);

    if (ranges) {
      this.ranges = this.addRange(ranges);
    }
  }

  _createClass(RangeContainer, [{
    key: "addRange",
    value: function addRange(range) {
      if (range instanceof Type || range.name === "Type") {
        var key = range.key,
            id = range.id,
            min = range.min,
            max = range.max;
        var values = {
          min: min,
          max: max
        };
        this[key] = values;
        this[id] = values;
      } else if (Array.isArray(range)) {
        for (var i = 0; i < range.length; i++) {
          this.addRange(range[i]);
        }
      } else {
        console.warn("Please only pass types to this method");
      }
    }
  }, {
    key: "selectRange",
    value: function selectRange(config) {
      if (Array.isArray(config)) {
        var randomRangeID = Math.floor(Math.random() * config.length);
        return this[config[randomRangeID]];
      }
    }
  }]);

  return RangeContainer;
}();